import { render, staticRenderFns } from "./month-table.vue?vue&type=template&id=adcf5d44&"
import script from "./month-table.vue?vue&type=script&lang=js&"
export * from "./month-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports